import React from 'react';

export default function FounderVision() {
  return (
    <section className="w-full bg-gray-950 text-white py-20 px-6 md:px-10">
      <div className="max-w-4xl mx-auto space-y-10">

        {/* Section Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-center">
          A Vision Rooted in Real Experience
        </h2>

        {/* Founder Intro */}
        <p className="text-lg text-gray-300 text-center">
          Hi, I’m <strong>Senthil Kumar</strong> — a trader turned tech entrepreneur with over 13 years of experience navigating markets, tools, and building platforms across India, UAE, and Africa.
        </p>

        {/* Backstory & Motivation */}
        <div className="text-gray-400 space-y-6 text-base leading-relaxed">
          <p>
            I’ve spent years watching talented market professionals — analysts, educators, brokers, signal providers — struggle to monetize, collaborate, or even build trust online. The tools are fragmented. Identities are lost. And monetization? Mostly broken.
          </p>
          <p>
            That’s why I started <span className="text-white font-semibold">Million2Trillion (M2T)</span> — a unified, role-based platform built for real financial professionals. Not just for content. Not just for trading. But as the infrastructure layer for financial credibility, collaboration, and scalable income.
          </p>
          <p>
            This is not just a product. It’s a mission — to help 1 million market professionals earn, grow, and thrive in a trustworthy digital ecosystem.
          </p>
        </div>

        {/* Optional Founder Note */}
        <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 shadow-md">
          <p className="text-gray-300 italic mb-2">
            “I believe the next trillion-dollar platforms will be founded by those who deeply understand both the user’s pain and the system’s limits. That’s what I bring to M2T — as both trader and builder.”
          </p>
          <p className="text-right text-sm text-gray-500">
            — Senthil Kumar (Mr. Senthee), Founder & CEO
          </p>
        </div>

      </div>
    </section>
  );
}
